/**
 * How the portal names a catalog entry that cannot be deployed. An entry that was superseded
 * (deprecated) or removed (archived) left the catalog; a draft, pending or rejected one was never
 * in it, so it is only "not available".
 */
export function leftTheCatalog(status: string | null | undefined): boolean {
  return status === 'deprecated' || status === 'archived'
}

/** The short label for an entry that cannot be deployed and that nothing replaced. */
export function notInCatalogLabel(status: string | null | undefined): string {
  return leftTheCatalog(status) ? 'Not in the catalog' : 'Not available in the catalog'
}

/** The sentence for the same entry: "no longer in the catalog" only when it was in it. */
export function notInCatalogPhrase(status: string | null | undefined): string {
  return leftTheCatalog(status) ? 'is no longer in the catalog' : 'is not available in the catalog'
}
